export const CONTENT = {
  hero: {
    title: 'Make stakeholder data work smarter, not harder',
    subtitle:
      'Centralise stakeholder data and transform thousands of inputs into clear, actionable intelligence with our AI-powered platform.',
    ctaText: 'Contact us',
  },
  knowledgeBase: {
    badge: 'Centralised Knowledge Base',
    title: 'The core of our Al platform for stakeholder data',
    description:
      'Our AI platform features a secure, centralised system for managing stakeholder data across time, teams, and formats. It enables time-based insight, smart categorisation, and pattern discovery – helping energy networks break data silos and make faster, more informed decisions.',
  },
  aiChat: {
    badge: 'AI BASE CHAT',
    title: 'Your gateway to instant stakeholder insight',
    description:
      'Our AI-powered chat gives you instant access to meaningful stakeholder insights. Ask questions directly, apply filters by group, topic, sentiment, or year, and get targeted results fast. Gain precise insights for reports and planning, and use prompts to explore deeper trends, shifts, and themes.',
  },
  triangulation: {
    badge: 'AI Triangulation Chat (TriChat)',
    title: 'Uncover stakeholder priorities with smart triangulation',
    description:
      'Our AI-powered Triangulation Function uses quantitative analysis to turn complex stakeholder feedback into clear, actionable insights. By examining patterns in sentiment, communication, and historical data, it highlights the most frequent topics and influential voices – offering a prioritised, data-driven view of stakeholder insight.',
  },
  testimonials: {
    badge: 'TESTIMONIALS',
    quote:
      "Given Ofgem's late decision to not roll over the GD2 price control, the time to carry out engagement and triangulate it alongside all of our existing evidence was cut short for the RIIO-GD3 business planning period. The quality of our submission was only made possible by the AI Triangulation Tool, which gave us the opportunity to upload new evidence and gain access to accurate synthesised insight immediately.",
    author: 'Wales and West Utilities',
  },
  navigation: {
    links: [
      { label: 'Product', href: '/home' },
      { label: 'Team', href: '/team' },
      { label: 'Contact us', href: '/contact-us' },
    ],
    loginText: 'Log in',
  },
  footer: {
    copyright: 'Sirio Strategies © 2025',
  },
};

export const ARIA_LABELS = {
  navigation: {
    main: 'Main navigation',
    mobile: 'Mobile navigation menu',
    toggle: 'Toggle mobile menu',
  },
  buttons: {
    login: 'Log in to your account',
    contact: 'Contact us for more information',
    send: 'Send message',
    download: 'Download file',
    copy: 'Copy to clipboard',
    sources: 'View sources',
    thumbsUp: 'Rate positively',
    thumbsDown: 'Rate negatively',
  },
  sections: {
    hero: 'Hero section',
    knowledgeBase: 'Knowledge base section',
    aiChat: 'AI chat section',
    triangulation: 'Triangulation section',
    testimonials: 'Testimonials section',
  },
};
